import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  MapLegend: {
    alignItems: 'center',
    backgroundColor: theme.palette.white,
    borderRadius: '4pt',
    bottom: '80px',
    boxShadow: `0 1px 3px ${theme.palette.iconDivider}, 0 1px 2px ${theme.palette.iconColor}`,
    display: 'flex',
    height: '20pt',
    justifyContent: 'space-between',
    maxWidth: 390,
    padding: '2pt 4pt',
    position: 'absolute',
    right: '1vw',
    width: '90%',
    '&__scale': {
      '&__gradient': {
        display: 'flex',
        flexDirection: 'column',
        maxWidth: 260,
        width: '90%',
        '&__dividers': {
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%',
        },
      },
    },
    '&__text': {
      '&--color': {
        color: theme.palette.sideBarBackgroundColor,
      },
    },
    '&__wrapper': {
      textAlign: 'center',
      whiteSpace: 'nowrap',
      width: '100%',
      '&__weather': {
        height: '4px',
        width: '100%',
        '&__temperature': {
          '&--background-image': {
            backgroundImage:
              'linear-gradient(to right, rgb(159, 85, 181) 0%, rgb(44, 106, 187) 8.75%, rgb(82, 139, 213) 12.5%, rgb(103, 163, 222) 18.75%, rgb(142, 202, 240) 25%, rgb(155, 213, 244) 31.25%, rgb(172, 225, 253) 37.5%, rgb(194, 234, 255) 43.75%, rgb(255, 255, 208) 50%, rgb(254, 248, 174) 56.25%, rgb(254, 232, 146) 62.5%, rgb(254, 226, 112) 68.75%, rgb(253, 212, 97) 75%, rgb(244, 168, 94) 82.5%, rgb(244, 129, 89) 87.5%, rgb(244, 104, 89) 93.75%, rgb(244, 76, 73) 100%)',
          },
        },
        '&__clouds': {
          '&--background-image': {
            backgroundImage:
              'linear-gradient(to right, rgba(247, 247, 255, 0) 0%, rgba(251, 247, 255, 0) 10%, rgba(244, 248, 255, 0.1) 20%, rgba(240, 249, 255, 0.2) 30%, rgba(221, 250, 255, 0.4) 40%, rgba(224, 224, 224, 0.9) 50%, rgba(224, 224, 224, 0.76) 60%, rgba(228, 228, 228, 0.9) 70%, rgba(232, 232, 232, 0.9) 80%, rgb(214, 213, 213) 90%, rgb(210, 210, 210) 95%, rgb(183, 183, 183) 100%)',
          },
        },
        '&__pressure': {
          '&--background-image': {
            backgroundImage:
              'linear-gradient(to right, rgb(0, 115, 255) 0%, rgb(0, 170, 255) 8.35059%, rgb(75, 208, 214) 24.9192%, rgb(141, 231, 199) 41.4879%, rgb(176, 247, 32) 49.7722%, rgb(240, 184, 0) 58.0565%, rgb(251, 85, 21) 74.6251%, rgb(243, 54, 59) 91.1938%, rgb(198, 0, 0) 100%)',
          },
        },
        '&__wind': {
          '&--background-image': {
            backgroundImage:
              'linear-gradient(to left, rgb(158, 128, 177), rgba(116, 76, 172, 0.9), rgb(164, 123, 170), rgba(170, 128, 177, 0.84), rgba(176, 128, 177, 0.71), rgba(170, 128, 177, 0.54), rgba(170, 128, 177, 0.44), rgba(255, 255, 0, 0))',
          },
        },
      },
    },
    '&--font-size': {
      fontSize: '10px',
    },
  },
  MapLegendCalc: {
    '&__wrapper': {
      '&__weather': {
        minWidth: 200,
      },
    },
  },
}));

export { useStyles };
